import { Component, OnDestroy, OnInit } from '@angular/core';

import { AlertService } from 'app/shared/util/alert.service';



@Component({
  selector: 'jhi-alert',
  template: `
    <div *ngFor="let alert of alerts" [class]="'d-flex align-items-center text-' + alert.type">
      <mat-icon fontSet="fill">error</mat-icon>
      <p class="pl-1 mb-0 lh-sm text-break" [innerHTML]="alert.msg">
        {{alert.msg}}
      </p>
      <button mat-icon-button (click)="alert.close(alerts)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  `,
})
export class JhiAlertComponent implements OnInit, OnDestroy {
  alerts: any[];

  constructor(private alertService: AlertService) {
  }

  ngOnInit() {
    this.alerts = this.alertService.get();
  }

  ngOnDestroy() {
    this.alerts = [];
  }

}
